// extracted by mini-css-extract-plugin
export default {"fullWidth":"en-z","image":"fn-z","lazyLoadPicture":"gn-z","lazyLoadSpinner":"hn-z","lazyLoadSpin":"in-z","lazyLoadImage":"jn-z","hasStyledAspectRatio":"kn-z"};